import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  showMicrocopy?: boolean;
};
export function CtaButton({
  label,
  id,
  showMicrocopy = false
}: CtaButtonProps) {
  return <div className="mx-auto w-full max-w-xl" data-id="element-29" data-mp="cksnad75h2e7">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[16px] font-extrabold uppercase leading-snug tracking-wide text-white shadow-[0_12px_28px_-10px_rgba(22,163,74,0.75)] ring-1 ring-inset ring-white/20 transition-[transform,background-color] duration-150 ease-out hover:bg-ctaDark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:text-lg" data-id="element-30" data-mp="cjzp40m9bl7o">
        <span data-id="element-31" data-mp="19bl3dau32ufz">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-32" data-mp="198p67oq289sl" />
      </a>
      {showMicrocopy && <p className="mt-3 text-center text-[13px] leading-relaxed text-muted" data-id="element-33" data-mp="35yz4uylwticl">
          Instant digital access · One-time payment of <strong className="text-ink" data-id="element-34" data-mp="3a0km0w5h8isl">$27</strong> · Lifetime access · 7-day money-back guarantee
        </p>}
    </div>;
}